module.exports = __webpack_public_path__ + "static/img/tv-asahi_group_initiatives.744ff79.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/company/tv-asahi_group_initiatives.svg
// module id = TNzO
// module chunks = 0